var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMscanLogoRivile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 591,
    height: 518,
    viewBox: "0 0 591 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_1799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0781 329.742C80.0781 311.621 66.2194 299.141 45.3429 299.141H0.850586V401.552H22.2337V363.256H38.6693L59.5458 401.724H83.3387L58.7 358.81C72.0423 352.982 80.0781 343.421 80.0781 329.742ZM40.8971 346.329H22.2337V316.239H40.8971C52.0165 316.239 58.3508 321.536 58.3508 330.429C58.3508 340.345 52.0165 346.329 40.8971 346.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.064 299.141H132.676V401.724H154.064V299.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.679 371.462L222.402 299.141H199.977L235.749 401.724H254.747L290.682 299.141H269.117L245.679 371.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.058 299.141H336.67V401.724H358.058V299.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.442 299.141H414.049V401.724H473.782V383.77H435.442V299.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 316.922V299.141H522.72V401.724H591V384.114H543.941V358.127H589.451V341.028H543.941V316.922H591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88 42.7324H103.527V64.101H308.88V42.7324Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 213.671H0.850586V235.039H103.527V213.671Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 170.938H0.850586V192.307H103.527V170.938Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.884 128.201H0.850586V149.57H308.884V128.201Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88 85.4697H103.527V106.838H308.88V85.4697Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88 0H103.527V21.3686H308.88V0Z",
    fill: "#00B373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4637 484.849V517.14H62.5312V487.531C62.5312 480.343 59.369 476.702 52.9413 476.702C46.5136 476.702 42.3924 481.684 42.3924 489.831V517.14H31.5533V487.531C31.5533 480.343 28.3911 476.702 21.9634 476.702C15.5357 476.702 10.9325 481.684 10.9325 489.831V517.14H0V467.701H9.68828L10.5489 474.123H10.9325C14.0013 469.234 18.7963 466.841 25.224 466.841C32.2271 466.841 37.2138 469.425 40.0908 474.604H40.376C43.5383 469.43 48.7168 466.841 55.8183 466.841C66.6574 466.841 73.4637 473.739 73.4637 484.853V484.849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2402 500.66H94.1728C94.1728 505.549 98.0087 508.615 104.245 508.615C110.481 508.615 113.741 506.792 113.741 503.058C113.741 500.183 111.538 498.267 107.22 497.407L98.4907 495.776C89.3778 493.953 84.7746 489.069 84.7746 481.213C84.7746 472.879 92.063 466.841 103.861 466.841C115.659 466.841 123.616 473.454 123.616 483.036H112.876C112.59 478.437 109.33 475.656 103.669 475.656C98.6825 475.656 95.4219 477.763 95.4219 481.311C95.4219 484.185 97.63 486.003 101.943 486.676L110.382 488.308C119.879 490.317 124.767 494.248 124.767 503.063C124.767 507.76 122.849 511.401 118.92 514.084C115.084 516.668 110.19 518.014 104.245 518.014C91.2023 518.014 83.5304 511.307 83.2402 500.67V500.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38 511.101C134.254 506.409 132.242 500.179 132.242 492.415C132.242 476.796 140.681 466.831 155.548 466.831C168.881 466.831 176.262 474.496 177.03 485.709H166.097C165.615 480.053 161.686 476.511 155.548 476.511C147.394 476.511 143.366 482.451 143.366 492.415C143.366 502.38 147.394 508.418 155.548 508.418C161.686 508.418 165.522 504.969 166.195 499.221H177.128C176.262 510.625 168.881 518 155.838 518C148.358 518 142.506 515.7 138.385 511.101H138.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.207 513.691C186.138 510.723 184.604 507.077 184.604 502.576C184.604 493.378 191.316 487.246 204.841 487.246H216.349V484.279C216.349 479.296 213.088 475.847 206.567 475.847C200.813 475.847 197.361 479.011 197.262 483.227H186.905C186.905 473.646 194.484 466.841 206.759 466.841C213.088 466.841 218.075 468.472 221.719 471.73C225.363 474.987 227.188 479.11 227.188 484.185V517.145H217.598L216.831 511.298H216.447C213.378 515.803 208.485 518.005 201.87 518.005C196.593 518.005 192.374 516.57 189.212 513.691H189.207ZM216.349 498.454V495.098H205.318C198.797 495.098 195.536 497.496 195.536 502.188C195.536 506.404 198.605 509.278 204.359 509.278C211.554 509.278 216.349 504.488 216.349 498.449V498.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.226 517.14V467.701H249.914L250.775 474.123H251.158C254.227 469.234 259.022 466.841 265.641 466.841C276.672 466.841 283.479 473.739 283.479 484.853V517.145H272.546V487.536C272.546 480.348 269.187 476.707 262.474 476.707C255.761 476.707 251.158 481.689 251.158 489.836V517.145H240.226V517.14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_1799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 591,
    height: 518,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMscanLogoRivile1);
export default __webpack_public_path__ + "static/media/mscan-logo-rivile 1.92dc8cdba130d05f20fc562406308d60.svg";
export { ForwardRef as ReactComponent };